export class Alert {
    message:string;
    blockContent:boolean;
    constructor (message:string,blockContent:boolean = null){
        this.message = message;
        if (blockContent !== null)
        {
            this.blockContent = blockContent;
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/alert/alert.ts